/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AttributeDefinition { 
    /**
     * Name of an Attribute that will be required when registering a Business Object Data of this Business Object Format                
     */
    name: string;
    /**
     * If true, this business object data attribute will be published in notification messages
     */
    publish?: boolean;
    /**
     * If true, this business object data attribute will be published in notification message headers and can be used to filter                   messages                
     */
    publishForFilter?: boolean;
}
